// extracted by mini-css-extract-plugin
export default {"assessmentLinkListContainer":"PropertyAssessmentLinksList_assessmentLinkListContainer__-y7FP","linkItem":"PropertyAssessmentLinksList_linkItem__qzr0E"};